import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { MessageContainer, SeparatorBlock } from '../styles';
import { Label, Row, Title, Value } from './styles';
import messages from './messages';

const rows = [
  ['knet_payment_id', messages.paymentId],
  ['knet_transaction_id', messages.transactionId],
  ['knet_transaction_time', messages.transactionTime],
  ['knet_amount', messages.amount],
  ['knet_status', messages.status],
];

export const findKnetPayment = payments =>
  payments?.find(payment => payment.details?.knet_payment_id != null);

const KnetPaymentDetails = ({ payment }) => (
  <>
    <SeparatorBlock />
    <MessageContainer>
      <Title>
        <FormattedMessage {...messages.title} />
      </Title>
      {rows.map(
        ([key, message]) =>
          payment.details[key] != null && (
            <Row key={key}>
              <Label>
                <FormattedMessage {...message} />
              </Label>
              <Value>
                <bdi dir="ltr">{payment.details[key]}</bdi>
              </Value>
            </Row>
          )
      )}
    </MessageContainer>
  </>
);

KnetPaymentDetails.propTypes = {
  /* eslint-disable camelcase */
  payment: PropTypes.shape({
    details: PropTypes.shape({
      knet_payment_id: PropTypes.string.isRequired,
      knet_transaction_id: PropTypes.string,
      knet_transaction_time: PropTypes.string,
      knet_amount: PropTypes.string,
      knet_status: PropTypes.string,
    }).isRequired,
  }).isRequired,
  /* eslint-enable camelcase */
};

export default KnetPaymentDetails;
